import React from "react";
import { useNavigate } from "react-router-dom";
import { useUserDispatch } from "../../../../context/user";
import { logoutUser } from "../../../../context/user/user.actions";
import styles from "./LogoutButton.module.css";

const handleLogoutClick = async (dispatch, navigate) => {
  if (
    window.confirm(
      "Are you sure you want to logout? All unsaved data will be lost."
    )
  ) {
    try {
      await logoutUser(dispatch, navigate);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  }
};

export const LogoutButton = () => {
  const dispatch = useUserDispatch();
  const navigate = useNavigate();

  return (
    <button
      onClick={() => handleLogoutClick(dispatch, navigate)}
      className={styles.logoutButton}
      data-testid="logout-button"
    >
      Logout
    </button>
  );
};
